/** @format */

import { useState } from 'react';
import './HomeSearch.css';

const sortOptionList = [
  { value: 'latest', name: '최신순' },
  { value: 'oldest', name: '오래된 순' },
  { value: 'highest', name: '획득고도 순' },
  { value: 'longest', name: '거리 순' },
  { value: 'shortest', name: '거리짧은 순' },
];

const ControlMenu = ({ value, onChange, optionList }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}>
      {optionList.map((it, idx) => (
        <option
          key={idx}
          value={it.value}>
          {it.name}
        </option>
      ))}
    </select>
  );
};

const HomeSearch = ({ homeSearchParentFunction }) => {
  const [sortType, setSortType] = useState('latest');
  const [search, setSearch] = useState('');

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const choiceRide = (it) => {
    sessionStorage.setItem('choiceRideId', JSON.stringify(''));
    homeSearchParentFunction(it.rideId);
    sessionStorage.setItem('choiceRideId', JSON.stringify(it.rideId));
    sessionStorage.setItem(
      'choiceRidePolyline',
      JSON.stringify(it.summary_polyline)
    );
  };

  const mapReset = (x) => {
    sessionStorage.setItem('choiceRideId', JSON.stringify(''));
    homeSearchParentFunction(x);
  };

  const userData = JSON.parse(sessionStorage.getItem('UserData'));
  const userRides = userData.rides;

  const getProcessedSearchResult = () => {
    const compare = (a, b) => {
      if (sortType === 'latest') {
        return new Date(b.start_date_local) - new Date(a.start_date_local);
      } else if (sortType === 'oldest') {
        return new Date(a.start_date_local) - new Date(b.start_date_local);
      } else if (sortType === 'longest') {
        return b.distance - a.distance;
      } else if (sortType === 'shortest') {
        return a.distance - b.distance;
      } else if (sortType === 'highest') {
        return b.total_elevation_gain - a.total_elevation_gain;
      }
    };

    const sortedList = userRides.sort(compare);

    const filterRideName = sortedList.filter((it) => {
      return it.name.toLocaleLowerCase().includes(search.toLocaleLowerCase());
    });

    return filterRideName;
  };

  return (
    <div className="searchBox">
      <div className="searchControlBox">
        <div className="searchTop">
          <ControlMenu
            value={sortType}
            onChange={setSortType}
            optionList={sortOptionList}
          />
          <a> 검색:</a>
          <input
            type="text"
            value={search}
            onChange={onChange}></input>
          <button onClick={mapReset}>전체보기</button>
        </div>
        <div className="fillterBox">
          <a className="Ride_Name">Ride Name</a>
          <a className="distance">distance</a>
          <a className="AVG_speed">speed</a>
          <a className="elevation">elevation</a>
        </div>
      </div>
      <div className="searchResultBox">
        {getProcessedSearchResult().map((it, rideId) => (
          <div
            div
            key={rideId}
            className="searchResultList"
            onClick={(e) => {
              choiceRide(it);
            }}>
            <div className="Ride_Name_Result">{it.name}</div>
            <div className="distance_Result">{it.distance.toFixed(1)} km</div>
            <div className="AVG_speed_Result">
              {it.average_speed.toFixed(1)} km/h
            </div>
            <div className="elevation_Result">
              {it.total_elevation_gain.toFixed(1)} m
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeSearch;
